import { render } from "./AuthLayout.vue?vue&type=template&id=6ccfbd76"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/AuthLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ccfbd76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ccfbd76', __exports__)) {
    console.log('reload')
    api.reload('6ccfbd76', __exports__)
  }
  
  module.hot.accept("./AuthLayout.vue?vue&type=template&id=6ccfbd76", () => {
    console.log('re-render')
    api.rerender('6ccfbd76', render)
  })

}


export default __exports__